import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

/**
 * Replaces DeviceDetectorService app-wide so that tablets are never "neither mobile nor desktop".
 * ngx-device-detector reports an iPad/Android-tablet user agent as tablet only, which leaves
 * `isMobile()` and `isDesktop()` both false and pages render without sidebar or bottom menu.
 *
 * Rule: desktop if the user agent is a desktop, or a tablet whose short screen side is >= 1000pt
 * (13" iPads, same rule as the iOS app); everything else is mobile.
 */
@Injectable()
export class BlancDeviceDetectorService extends DeviceDetectorService {

  private static readonly LARGE_TABLET_MIN_SHORT_SIDE = 1000;

  isDesktop(userAgent?: string): boolean {
    return super.isDesktop(userAgent) || (super.isTablet(userAgent) && this.isLargeTablet());
  }

  isMobile(userAgent?: string): boolean {
    return !this.isDesktop(userAgent);
  }

  private isLargeTablet(): boolean {
    if (typeof window === 'undefined' || !window.screen) {
      return false;
    }
    return Math.min(window.screen.width, window.screen.height) >= BlancDeviceDetectorService.LARGE_TABLET_MIN_SHORT_SIDE;
  }
}
